import React from 'react';
import styles from '../../styles/effects/FogEffect.module.scss';

interface FogEffectProps {
  isDay?: boolean;
}

const FogEffect: React.FC<FogEffectProps> = ({ isDay }) => {
  const mists = Array.from({ length: 30 }).map((_, i) => {
    const top = Math.random() * 100; // anywhere vertically
    const width = 100 + Math.random() * 100; // 100%–200% width
    const height = 50 + Math.random() * 100; // 50px–150px tall
    const opacity = 0.1 + Math.random() * 0.2; // 0.1–0.3 max opacity

    const driftDuration = 40 + Math.random() * 20; // 40s–60s across
    const driftDelay = -Math.random() * driftDuration;

    // slower fade: 20s–40s fade cycle
    const fadeDuration = 20 + Math.random() * 20;
    const fadeDelay = -Math.random() * fadeDuration;

    return (
      <div
        key={i}
        className={styles.mist}
        style={
          {
            top: `${top}%`,
            width: `${width}%`,
            height: `${height}px`,
            '--opacity': opacity,
            animationDuration: `${driftDuration}s, ${fadeDuration}s`,
            animationDelay: `${driftDelay}s, ${fadeDelay}s`,
          } as React.CSSProperties
        }
      />
    );
  });

  return (
    <div className={`${styles.fog} ${isDay ? styles.day : ''}`}>
      <div className={styles.overlay} />
      {mists}
    </div>
  );
};

export default FogEffect;
